import { jsx as m } from "react/jsx-runtime";
import p from "react";
import { cn as $ } from "../../utils/cn.js";
const v = p.forwardRef((t, i) => {
  const {
    className: a,
    gap: o,
    justify: s,
    align: e,
    reverse: r,
    wrap: f,
    fullWidth: l,
    breakpoints: n,
    children: c,
    ...u
  } = t, g = x(n), d = $(
    "gst-flex gst-flex-col",
    f && "gst-flex-wrap",
    l && "gst-w-full",
    r && "gst-flex-col-reverse",
    j(o) || "",
    s !== "start" && `gst-justify-${s}`,
    e !== "stretch" && `gst-items-${e}`,
    ...g,
    a
  );
  return /* @__PURE__ */ m("div", { ref: i, className: d, ...u, children: c });
});
v.displayName = "Col";
const x = (t) => t ? Object.entries(t).flatMap(([i, a]) => {
  const { gap: o, justify: s, align: e } = a || {}, r = i === "xs" ? "" : `${i}:`;
  return [
    o !== void 0 ? `${r}gst-gap-${o}` : void 0,
    s ? `${r}gst-justify-${s}` : void 0,
    e ? `${r}gst-items-${e}` : void 0
  ].filter(Boolean);
}) : [], j = (t) => {
  if (t !== void 0)
    return typeof t == "number" ? `gst-gap-${t}` : t.startsWith("x-") || t.startsWith("y-") ? `gst-gap-${t}` : `gst-gap-${t}`;
};
export {
  v as default
};
